export { default, getStaticProps, getStaticPaths } from "../patients-v2/[[...params]]";